// extracted by mini-css-extract-plugin
export default {"banner":"styles_banner__91qD+","inner":"styles_inner__NzFtd","text":"styles_text__7fmsr"};